import Appsignal from '@appsignal/javascript'
import { plugin } from '@appsignal/plugin-window-events'
import { isDev } from './utils/env'

// Ruis die niets over onze code zegt: afgebroken netwerkverkeer en DOM-ingrepen
// van in-app browsers.
const BROWSER_NOISE = [
  /removeChild/,
  /not a child of this node/,
  /room_locked/,
  /Failed to fetch dynamically imported module/,
  /Failed to fetch/,
  /Load failed/,
]

// React-hydratiefouten die uit diezelfde DOM-ingrepen volgen.
const REACT_NOISE = [/Hydration failed/, /React error #418/, /Maximum call stack size exceeded/]

let appsignal: Appsignal | null = null

if (typeof window !== 'undefined' && typeof Appsignal === 'function' && !isDev) {
  appsignal = new Appsignal({
    key: '675da74e-2f7f-4938-8bda-0dc7657fda25',
    revision: typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'unknown',
  })

  appsignal.use(
    plugin({
      ignoreErrors: [...BROWSER_NOISE, ...REACT_NOISE],
    })
  )

  // sendError() (bv. vanuit de AppSignal-ErrorBoundary) gaat langs de plugin heen,
  // dus dezelfde React-ruis moet hier nog een keer weggefilterd worden.
  const originalSendError = appsignal.sendError.bind(appsignal)
  appsignal.sendError = ((error: Error, ...args: unknown[]) => {
    if (REACT_NOISE.some((pattern) => pattern.test(error?.message || ''))) return
    return originalSendError(error, ...(args as []))
  }) as typeof appsignal.sendError
}

export default appsignal
